import type { CSSProperties } from 'react';
import { DateTime } from '@ksyos/date-time';
import { Component } from 'react';
import { connect } from 'react-redux';
import type { IReduxState } from '../../configureStore';
import { translateKey } from '../../translate';

interface IDisplayDatePassedProps {
    className?: string;
    isTimeHidden?: boolean;
    style?: CSSProperties;
    value?: Date | string | null;
}

interface IDisplayDatePassedReduxProps {
    languageCode: string;
}

const mapStateToProps = ({ language: { code: languageCode } }: IReduxState): IDisplayDatePassedReduxProps => ({
    languageCode,
});

export class DisplayDatePassedWrapper extends Component<IDisplayDatePassedProps & IDisplayDatePassedReduxProps, {}> {
    public render() {
        if (!this.props.value) {
            return null;
        }

        const date = DateTime.from(this.props.value);
        const today = DateTime.today();

        let result;
        if (!this.props.isTimeHidden) {
            if (date.isSame(today, 'd')) {
                result = date.formatFromNow();
            } else {
                result = date.formatFromNowAsCalendar();
            }
        } else {
            result = date.formatFromNowAsCalendar(null, {
                sameDay: `[${translateKey('common.date_today')}]`,
                nextDay: `[${translateKey('common.date_tomorrow')}]`,
                nextWeek: 'l',
                lastDay: `[${translateKey('common.date_yesterday')}]`,
                lastWeek: `[${translateKey('common.date_last')}] dddd`,
                sameElse: 'l',
            });
        }

        return (
            <div
                className={this.props.className ?? ''}
                style={this.props.style}
            >
                {result.replace(/^[a-z]{1}/g, (letter) => letter.toUpperCase())}
            </div>
        );
    }
}

export const DisplayDatePassed = connect(mapStateToProps)(DisplayDatePassedWrapper);
